import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { TrackingContext } from '@vrbo/react-event-tracking';
import SubmitButton from '../../Button/SubmitButton';
import useUpdateContact from './useUpdateContact';

export { UPDATE_CONTACT } from './useUpdateContact';

function MissingDetailsSubmit(props) {
    const {
        onCompleted,
        validPhone,
        onError,
        duaid,
        hasPhoneNumber,
        passwordValidation,
        hasPasswordSet
    } = props;
    const { trigger } = useContext(TrackingContext);
    const { submitContact, inFlight } = useUpdateContact({ onCompleted, onError });
    const onClick = async () => {
        trigger('genericClick', {
            category: 'navigation',
            action: 'MissingDetails: nextButton'
        });
        const {
            password,
            phoneCountryCode,
            phoneCountryCodeDigits,
            phoneNumber,
            locale,
            fingerprint
        } = props;

        await submitContact({
            password,
            phoneCountryCode,
            phoneCountryCodeDigits,
            phoneNumber,
            locale,
            fingerprint,
            duaid
        });
    };
    const {
        ctaLabel
    } = props;
    return (
        <div>
            <SubmitButton
                animated={inFlight}
                label={ctaLabel}
                onClick={onClick}
                data-wdio="submit-button"
                disabled={
                    (!validPhone && !hasPhoneNumber)
                    || (!hasPasswordSet && !passwordValidation?.isValid)
                }
            />
        </div>
    );
}

MissingDetailsSubmit.propTypes = {
    ctaLabel: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
    phoneCountryCode: PropTypes.string.isRequired,
    phoneCountryCodeDigits: PropTypes.string.isRequired,
    phoneNumber: PropTypes.string.isRequired,
    hasPhoneNumber: PropTypes.bool.isRequired,
    validPhone: PropTypes.bool.isRequired,
    locale: PropTypes.string.isRequired,
    onError: PropTypes.func.isRequired,
    onCompleted: PropTypes.func.isRequired,
    fingerprint: PropTypes.shape({
        orgId: PropTypes.string,
        deviceId: PropTypes.string
    }).isRequired,
    duaid: PropTypes.string.isRequired,
    hasPasswordSet: PropTypes.bool.isRequired,
    passwordValidation: PropTypes.shape({
        isValid: PropTypes.bool.isRequired,
        error: PropTypes.string
    }).isRequired
};

export default MissingDetailsSubmit;
